/* RESPONSIBLE TEAM: team-ai-insights */
import type AppService from 'embercom/services/app-service';
import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import type IntlService from 'embercom/services/intl';
import type Transition from '@ember/routing/-private/transition';
import type ReportingMetrics from 'embercom/services/reporting-metrics';
import { taskFor } from 'ember-concurrency-ts';
import ConversationAttributeDescriptor from 'embercom/models/conversation-attributes/descriptor';
import { hash } from 'rsvp';
import type AiAgentSetupService from 'embercom/services/ai-agent-setup-service';
import type ReportingUnderlyingDataService from 'embercom/services/reporting-underlying-data-service';
import { markViewAsSeen } from 'embercom/lib/admin-view-tracking';

export const ANALYZE_PERFORMANCE_PAGEVIEW_KEY = 'fin_ai_agent_analyze_performance';

export default class FinAIAgentAnalyzePerformanceRoute extends Route {
  @service declare intl: IntlService;
  @service declare permissionsService: $TSFixMe;
  @service declare reportingMetrics: ReportingMetrics;
  @service declare appService: AppService;
  @service declare aiAgentSetupService: AiAgentSetupService;
  @service declare reportingUnderlyingDataService: ReportingUnderlyingDataService;
  @service declare store: $TSFixMe;

  get titleToken() {
    if (this.appService.app.canUseFeature('fin-sales-agent')) {
      return this.intl.t('ai-agent.analyze.performance.support-performance-title');
    }
    return this.intl.t('ai-agent.analyze.performance.title');
  }

  async beforeModel(transition: Transition) {
    this.permissionsService.ensurePermissionWhenTransitioning('can_access_reporting', transition);

    markViewAsSeen(this.store, ANALYZE_PERFORMANCE_PAGEVIEW_KEY);

    let promises = [
      taskFor(this.reportingMetrics.setup).perform(),
      taskFor(this.reportingUnderlyingDataService.loadAttributeMappings).perform(
        'conversation_custom_fields#customer_experience_attributes',
        'conversation',
        true,
      ),
    ];
    if (!this.appService.app.isStandaloneApp) {
      promises.push(
        taskFor(this.reportingUnderlyingDataService.loadAttributeMappings).perform(
          'conversation.workflow_conversation_rating.workflow_id',
          'conversation',
          true,
        ),
      );
    }
    await Promise.all(promises);
    this.aiAgentSetupService.loadFinWorkflowsCount();
    this.aiAgentSetupService.loadSetupRulesets();
  }

  async model() {
    let conversationAttributeDescriptors = [];

    if (this.appService.app.canUseFeature('conversation_attributes')) {
      conversationAttributeDescriptors =
        await ConversationAttributeDescriptor.peekAllAndMaybeLoad();
    }

    return hash({
      conversationAttributeDescriptors,
    });
  }
}
